import React, { useEffect } from 'react';
import Contact from '../../components/contact/Contact'
import Nav from '../../components/nav/Nav';
import Loader from '../../components/preloader/Loader';

function ContactPage({ loaderFinished, setLoaderFinished }) {
  useEffect(()=>{
    setLoaderFinished(false);
  },[setLoaderFinished]);
  return (
    <div>
        <Loader loaderFinished={setLoaderFinished} data="contact" show2={false} />
        {loaderFinished && (
          <>
            <Nav inHome={true}/>
            <Contact/>
          </>
        )}
    </div>
  )
}

export default ContactPage